<template>
  <!--
    - On va chercher le lemma de l'expression
  -->
  <div class="flexwrap centercenter">
    <!--
    <span v-for="(word, index) in sentence.split(' ')" :key="index">
      <span :class="[isLemma(word) ? 'lemma' : '' ]">
        {{word}}
      </span>

    </span>-->
    <span v-html="colouredSentence()"></span>

  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "coloredLemmas",

  props: {
    sentence: String,
    lemma: String,
    type: String,
    color: String
  },
  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },
  methods: {
    //Reconstruit et renvoie un string contenant les balises de colorations du ou des lemmas
    colouredSentence: function() {
      let HTMLSentence = "";
      //On sépare les mots de la phrase

      let wordsArray = this.sentence.split(" ");
      //On parcourt le tableau de mots pour vérifier s'ils correspondent à un des lemmas en cours (en enlevant les expressions régulières)
        //Si non, on ajoute juste le mot à HTMLSentence
        //Si oui
          //-Si le mot correspond exactement à un lemma, on lui ajoute la balise de coloration
          //-S'il faut enlever une ou des regEx, on les récupère pour isoler le mot et lui appliquer la balise de coloration
      wordsArray.forEach((lemma) => {
        if(!this.isLemma(lemma, true)) {
          HTMLSentence+= ' ' + lemma;
        }
        else {
          if(this.isLemma(lemma, false)) {
            HTMLSentence+= " " + "<span style='color: var(--learnColor)'>" + lemma + "</span>"
          }
          else {
            //permettra de repérer le premier charactère normal
            const globalRegex = RegExp(/^[a-zA-Z]/, 'g');
            //permet de repérer les charactères spéciaux
            const globalIrregEx = RegExp(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, 'g');

            let preLemma = "";
            let trueLemma = "";
            let postLemma = "";

            //On récupère la position du premier character normal
            let firstReg = 0;
            globalRegex.test(lemma);
            firstReg = globalRegex.lastIndex-1;

            preLemma = lemma.substr(0, firstReg);
            trueLemma = lemma.substr(firstReg);

            //On récupère la position du premier character spécial suivant le premier character normal
            let firstSpe = 0;
            globalIrregEx.test(trueLemma);
            firstSpe = globalIrregEx.lastIndex-1;
            postLemma = trueLemma.substr(firstSpe);
            trueLemma = trueLemma.substr(0, firstSpe);

            HTMLSentence+= " " + preLemma + "<span style='color: var(--learnColor)'>" + trueLemma + "</span>" + postLemma
          }
        }
      })

      return HTMLSentence;
    },

    //Retourne si le mot correspond à un lemma
    isLemma: function(word, regEx) {
      let trimWord = word.toLowerCase();
      if (regEx === true) {
        trimWord = word.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
      }
      let lemmatizer = require('wink-lemmatizer');

      let match = false;
      this.lemma.split(' ').forEach((lemma) => {
        if (this.type === "n") {
          if (lemmatizer.noun(trimWord) == lemma) {
            match = true;
          }
        } else if (this.type === "v") {
          if (lemmatizer.verb(trimWord) == lemma) {
            match = true;
          }
        } else {
          if (lemmatizer.adjective(trimWord) == lemma) {
            match = true;
          }
        }
      })

      if(match) {
        return true
      }
      return false;
    }
  },


  data() {
    return {

    }
  }
}
</script>

<style scoped>
  .lemma {
    color: #d44337;
  }

  .notLemma {
    color: whitesmoke;
  }
</style>